/**
 * Best-effort grid from Unstructured/plain table text:
 * - one row per non-empty line
 * - cells split on tab (common after HTML→plain conversion)
 * Falls back to null when the blob looks like prose (single huge line, no tabs).
 */
export function tryParsePlainTableGrid(text: string): string[][] | null {
  const normalized = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n").trim();
  if (!normalized) return null;

  const rawLines = normalized.split("\n");
  const lines = rawLines.map((l) => l.trim()).filter((l) => l.length > 0);
  if (lines.length === 0) return null;

  const hasAnyTab = lines.some((l) => l.includes("\t"));
  const maxLineLen = Math.max(...lines.map((l) => l.length));

  // Likely prose paragraph: one line, no tabs, very long
  if (lines.length === 1 && !hasAnyTab && maxLineLen > 520) {
    return null;
  }

  const rows = lines.map((line) =>
    hasAnyTab ? line.split("\t").map((c) => c.trim()) : [line]
  );

  const maxCols = Math.max(1, ...rows.map((r) => r.length));
  return rows.map((r) => {
    const next = [...r];
    while (next.length < maxCols) next.push("");
    return next;
  });
}
